import React from 'react';
import { Row, Col, Image, Typography, Button, Tooltip, message, Dropdown, Menu, Badge, List, Avatar, Space, Card } from 'antd';
import { DownOutlined, DownloadOutlined, FilePdfOutlined, MailTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { fileDetailsFromURL, phoneMask, moneyMask, getAvatar, channelTypeLabel } from 'src/common/utils';
import * as dayjs from 'dayjs';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { IoCheckmarkSharp, IoCheckmarkDoneSharp, IoCloseSharp, IoChevronDown, IoTrash, IoTrashOutline, IoArrowRedoOutline, IoArrowForward, IoChatbubblesSharp, IoPhoneLandscape, IoCallOutline, IoCallSharp, IoMailSharp } from "react-icons/io5";
import { FaRegClock, FaReply } from "react-icons/fa";
import { uniqueId } from 'lodash';
import axios from 'axios';
import { PRIVATE_STORAGE_API } from 'src/common/constants';
import { ChatMessageQuoted } from '../chat-message-quoted';
import { useHistory, useLocation } from 'react-router-dom';
import useIsMobile from 'src/hooks/use-is-mobile';

export const ChatMessageContent = (props) => {
    const { Text } = Typography
    const { style, message, user, company, onRevokeMessage, onReplyMessage,...viewProps } = props;
    const [visible, setVisible] = React.useState(false);
    const [contentUrl, setContentURL] = React.useState(message.content);
    let isMobile = useIsMobile();
    let history = useHistory();
    let location = useLocation();
    React.useEffect(()=>{
      let q = new URLSearchParams(location.search).get("t")
      const proxyFile = async (url) => {
          let res = await axios.get(`${message?.content}`, { 
              headers: {
                'Authorization': `Bearer ${q}`
              }
          })
          setContentURL(res.data?.url)
      }
      
      if(message?.content?.indexOf(PRIVATE_STORAGE_API) !== -1 && message.content_type !== 'vcard'){
          proxyFile(message.content);
      }else{
          setContentURL(message.content);
      }
  },[message?.content]);
    const renderDateElement = ()=> (
        <Text style={{marginLeft: '10px'}}>
        {dayjs(message.received_at).format('DD/MM/YY')} ás {dayjs(message.received_at).format('HH:mm')}
        </Text>
    );
    const renderUser = () => {
        return (
            <Tooltip title={`${user?.name} está ${user?.online ?'online.':'offline.'}`}>
            <Text className="message-author">
                {user?.online ? <Badge status="success"></Badge>:<Badge status="error" /> } <Text>{user?.name}</Text>
            </Text>
            </Tooltip>
        );
    }
    const renderOptinRequest = () => {
        let payload;
        try{
            payload = JSON.parse(message.content)
        }catch(err){
            console.error(err)
            payload = {}
        }
        let { title, footer,  body } = payload
        return(
            <Card title={title}  size={"small"} className="optin-card">
            <Row>
            {body && 
                <Row>
                    <Text type='title'>{body}</Text>
                </Row>
            }
            {footer && 
            <Row style={{marginTop: 12}}>
                <Text style={{color: "#6f6f6f", fontSize: 12}}>{footer}</Text>
            </Row>
            }
            </Row>
            </Card>
        
        )
    }
    const renderHSMTemplate = () => {
        let payload;
        try{
            payload = JSON.parse(message.content)
        }catch(err){
            console.error(err)
            payload = {}
        }
        let { header, body,  footer, buttons } = payload.rendered_message||{};
        
        const getCover = (parameter) => {
            if(!parameter){
                return null
            }
            if(parameter.type === "video"){
                return <video className="message-video" controls src={parameter[parameter.type].link}> </video>
            }
            if(parameter.type === "image"){
                return <Image 
                    preview={visible} 
                    width={'100%'}
                    fallback={"https://storage.chatbee.com.br/public-uploads/image-error-fallback.png"}
                    src={parameter[parameter.type].link} 
                    onClick={() => setVisible(true)}
                />
            }
            if(parameter.type === "document"){
                let { ext } = fileDetailsFromURL(parameter[parameter.type].link)
                return <Row>
                    <Col span={12}>
                        <Text className="document-attachment" strong>Documento em Anexo</Text>
                    </Col>
                    <Col span={12}>
                        <Row justify={"end"}>
                        <Button type="primary"  className="document-attachment" icon={<DownloadOutlined />} size={"small"} onClick={()=> downloadURI(parameter[parameter.type].link, `${parameter[parameter.type].filename}.${ext}`)}>
                            Baixar
                        </Button>
                        </Row>
                    </Col>
                </Row>
            }
            return null
        }
        return(
            <>
            <Card cover={getCover(header)||getCover(body)||getCover(footer)||getCover(buttons)} title={header?.text}  size={"small"} className="optin-card">
            <Row>
            {body?.text && 
                <Row>
                    <Text type='title'>{body?.text}</Text>
                </Row>
            }
            {footer?.text && 
            <Row style={{marginTop: 12}}>
                <Text style={{color: "#6f6f6f", fontSize: 12}}>{footer?.text}</Text>
            </Row>
            }
            
            </Row>
           
            </Card>
            <Col span={24}>
                <Row justify="space-between" style={{marginTop: 10}}>
                    {buttons?.buttons && 
                        buttons?.buttons?.map((btn)=><Button  href={btn.url}>{btn.text}</Button>)
                    }
                </Row>
            </Col>
            </>
        )
    }
    const renderOptinRequestOptions = () => {
        let payload;
        try{
            payload = JSON.parse(message.content)
        }catch(err){
            console.error(err)
            payload = {}
        }
        let { options } = payload
        return(
            <Row justify={"space-between"} gutter={[8,8]}>
                {options?.map((item)=><Col span={24/options.length} key={item.id}><Button block type="text" style={{border: '1px solid #e9e9e9'}}><Typography.Text strong> {item.body}</Typography.Text></Button></Col>)}
            </Row>
        )
    }
    const renderButtonsResponse = () => {
        let payload;
        try{
            payload = JSON.parse(message.content)
        }catch(err){
            console.error(err)
            payload = {}
        }
        let { id, text } = payload
        return(
            <Col span={24}>
                <Button  block type="text" style={{border: '1px solid #e9e9e9'}}><Typography.Text strong> {text}</Typography.Text></Button>
            </Col>
        )
    }
    const renderPtv= () => {
        return (
            <video className="message-video" controls src={contentUrl}> </video>
        );
    }
    const renderVCard = () => {
        let payload = JSON.parse(message.content)
        let cards = payload.vcards || [];
        let contacts = cards.map((vcard)=>{
            return {
                name: vcard.FN, 
                address: vcard.TEL,
                type: vcard.WHATSAPP ? 'wa':'sms',
                email: vcard.EMAIL,
                profile_picture_url: vcard.PHOTO ? vcard.PHOTO: 'https://storage.4bytes.com.br/public-uploads/default-avatar.jpg'
            }
        })
        return (
            <Row wrap={true}>
            <List itemLayout="horizontal"  dataSource={contacts} style={{minWidth: 350}} renderItem={item => (
                <List.Item key={uniqueId()} >
                    <List.Item.Meta
                    avatar={
                        <>
                            <Avatar size={54} src={item.profile_picture_url || "https://storage.4bytes.com.br/public-uploads/default-avatar.jpg"} />
                            <Image className="channel-type-tag" preview={false} src={getAvatar(null, item.type)}/>
                        </>
                    }
                    title={<>
                        <Row>
                            {item.name}
                        </Row>
                        
                    </>}
                    description={<>
                        {item.address && <Row>
                            <Text ellipsis={true} copyable={{text: item.address}}>{item.address}</Text>
                        </Row>}
                        {item.email && <Row>
                            <Text ellipsis={true} copyable={{text: item.email}}>{item.email}</Text>
                        </Row>}
                    </>}
                    />
                    <Space direction="vertical">
                        <Button size={"small"} target={"_blank"} type="link" href={`tel:${item.address}`}>
                            <IoCallSharp style={{color: 'green'}}/>
                        </Button>
                        {item.email && <Button  size={"small"} type="link" target={"_blank"} href={`mailto:${item.email}`}>
                            <IoMailSharp style={{color: 'blue'}}/>
                        </Button>}
                        <Button size='small' type='link'  onClick={()=>history.push(`/?to=${item.address}`)}>
                            <IoChatbubblesSharp/>
                        </Button>
                    </Space>
                </List.Item>
            
        )}/>
        </Row>);
    }
    const renderProfile = ()=> (
        <Text className="message-author">
          {message.chatbot_uuid ? "Bot" : (props.contact?.custom_name ? props.contact?.custom_name: props.contact?.name)}
        </Text>
    );
    const renderExternalDevice = ()=> (
        <Text className="message-author">
          {message.external_device === "android" && <Text>[Dispositivo Externo] - Enviado do Android</Text>}
          {message.external_device === "ios" && <Text>[Dispositivo Externo] - Enviado do iOS</Text>}
          {message.external_device === "web" && <Text>[Dispositivo Externo] - Sessão Externa do WhatsApp Web</Text>}
        </Text>
    );
    function replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    const generateAddressDescription = (raw_value, cep_info) => {
        let desc = "";
        if(cep_info?.logradouro){
            desc += `Logradouro: ${cep_info.logradouro}`;
        }
        if(cep_info?.complemento){
            desc += ` - ${cep_info.complemento}`;
        }
        if(cep_info?.bairro){
            desc += ` ${cep_info.bairro}`;
        }
        if(cep_info?.localidade){
            desc += ` - ${cep_info.localidade}`;
        }
        if(cep_info?.uf){
            desc += `/${cep_info.uf}`;
        }
        desc += ` CEP: ${raw_value}`;
        return desc
    }
    const getParsedValue = (entity) => {
        if(entity.parsed && entity.parsed.length){
            return entity.parsed[0]['value']
        }
        return '';
    }
    const renderParserOutput = () => {
        let texts = []
        if(!message.entities || message.entities?.length === 0){
            texts.push(<Text className='render-line-break' key={uniqueId("text-")}>{message.content}</Text>)
        }
        if(message.entities){
            for(var key in message.entities){
                let index = parseInt(key)
                let entity = message.entities[index]
                let nextEntity = message.entities.length > index ? message.entities[index+1] : null
                if(index == 0){
                    texts.push(<Text className='render-line-break' key={uniqueId("text-")}>{message.content.substring(0, entity.start)}</Text>)
                }
                switch(entity.label){
                    case "DATETIME":
                        texts.push(
                            <Tooltip title={dayjs(getParsedValue(entity)).format("DD/MM/YYYY")} key={uniqueId("entity-")}>
                                <Text className='render-line-break' strong style={{}}>{entity.text}</Text>
                            </Tooltip>
                        );
                        break;
                    case "URL":
                        texts.push(
                            <Tooltip title={"Clique para abrir em uma nova aba"} key={uniqueId("entity-")}>
                                <Button size={"small"} style={{padding: "0px", color: "#027eb5"}}  type="link" target={"_blank"} href={`${getParsedValue(entity)}`}>{entity.text}</Button>
                            </Tooltip>
                        );
                        break;
                    case "CREDIT_CARD_NUMBER":
                        texts.push(
                            <Tooltip title={"Número de Cartão de Crédito"} key={uniqueId("entity-")}>
                                <Text className='render-line-break' style={{}} >{replaceAll(entity.text, /\d/, "X")}</Text>
                            </Tooltip>
                        )
                        break;
                    case "PHONE_NUMBER":
                        texts.push(
                            <Tooltip title={`Ligar para: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text copyable={{text: getParsedValue(entity)}}>
                                    <Button size={"small"} style={{padding: "0px", color: "#027eb5"}}  type="link" target={"_blank"} href={`tel:${getParsedValue(entity)}`}>
                                        {entity.text}
                                    </Button>
                                </Text>
                            </Tooltip>
                        )
                        break;
                    case "EMAIL_ADDRESS":
                        texts.push(
                            <Tooltip title={`Enviar e-mail para: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text copyable={{text: getParsedValue(entity)}}>
                                <Button className='render-line-break' size={"small"} style={{padding: "0px", color: "#027eb5"}}  type="link" target={"_blank"} href={`mailto:${getParsedValue(entity)}`}>
                                    {entity.text}
                                </Button>
                                </Text>
                            </Tooltip>
                        )
                        break;
                    case "AMOUNT_OF_MONEY":
                        texts.push(
                            <Tooltip title={moneyMask(getParsedValue(entity), entity.parsed && entity.parsed.length > 0 ?entity.parsed[0]['unit']:'')} key={uniqueId("entity-")}>
                                <Text className='render-line-break' strong style={{}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "IPV4_ADDRESS":
                        texts.push(
                            <Tooltip title={`Endereço de IP: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "CPF":
                        texts.push(
                            <Tooltip title={`CPF Válido: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false, text: getParsedValue(entity)}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "CNPJ":
                        texts.push(
                            <Tooltip title={`CNPJ Válido: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false, text: getParsedValue(entity)}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "PERCENTILE":
                        texts.push(
                            <Tooltip className='render-line-break' title={`Percentil: ${getParsedValue(entity)}%`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false, text: getParsedValue(entity)}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "CEP":
                        texts.push(
                            <Tooltip className='render-line-break' title={`${generateAddressDescription(entity.parsed[0].value, entity.parsed[0].info)}`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false, text: getParsedValue(entity)}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    case "CORREIOS_TRACKING_CODE":
                        texts.push(
                            <Tooltip className='render-line-break' title={`Código de Rastreio dos Correios: ${getParsedValue(entity)}`} key={uniqueId("entity-")}>
                                <Text className='render-line-break' copyable={{tooltips: false, text: getParsedValue(entity)}} style={{color: '#027eb5'}}>{entity.text}</Text>
                            </Tooltip>
                        )
                        break;
                    default:
                        texts.push(
                            <Text className='render-line-break' key={uniqueId("entity-")} strong style={{}}>{entity.text}</Text>
                        )
                        break;
                }
                if(nextEntity){
                    texts.push(<Text className='render-line-break' key={uniqueId("text-")}>{message.content.substring(entity.end, nextEntity.start)}</Text>)
                }
                if(index == message.entities.length -1){
                    texts.push(<Text className='render-line-break' key={uniqueId("text-")}>{message.content.substring(entity.end, message.content.length)}</Text>)
                }
            }
        }
        return texts
    }
    const renderText = () => {
        let texts = [];
        if(company?.settings?.nlp?.enable_entity_parsing){
            texts = renderParserOutput()
        }else{
            texts = [<Text className='render-line-break' key={uniqueId()}>{message.content}</Text>]
        }
        return (
            <Text className='render-line-break' key={uniqueId()}>
                {texts}
            </Text>
        );
    }
    const renderDeletedMessage = () => {
        return (
        <>
            {message.content_type === "text" && 
                <Tooltip title={ message.status === 3 ? "Mensagem apagada.": dayjs(message.received_at).format("HH:mm")} placement={"bottomRight"}>
                    <Text><del>{message.content}</del></Text>
                </Tooltip>
            }
            {message.content_type !== "text" && 
                <Tooltip title={ message.status === 3 ? "Mensagem apagada.": dayjs(message.received_at).format("HH:mm")} placement={"bottomRight"}>
                    <Text>Essa mensagem foi apagada.</Text>
                </Tooltip>
            }
        </>
        );
    }
    function downloadURI(uri, name) {
        fetch(uri).then(response => response.blob())
        .then(blob => {
            const link = document.createElement("a");
            link.target = "_blank";
            link.href = URL.createObjectURL(blob);
            link.download = name;
            link.click();
        })
        .catch(console.error);
    }
    const renderDocument = () => {
        const { filename } = fileDetailsFromURL(contentUrl)
        return (
            <>
                <Text className="document-attachment">Enviou um documento</Text>
                <Button type="primary" className="document-attachment" icon={<FilePdfOutlined />} size={"small"} onClick={()=> downloadURI(contentUrl, filename)}>
                    Download
                </Button>
            </>
        );
    }
    const renderAudio = () => {
        return (
            <audio controls src={contentUrl}> </audio>
        );
    }
    const renderVideo = () => {
        return (
            <video className="message-video" controls src={contentUrl}> </video>
        );
    }
    const renderStory = (type) => {
        let url = new URL(message.content)
        let mime = url.searchParams?.get("story_type") || "not_available"
        return (
        <>
            <Col>
                <Row wrap>
                    {mime.includes("image") && 
                        <Image 
                            preview={visible} 
                            width={200} 
                            fallback={"https://storage.4bytes.com.br/public-uploads/image-error-fallback.png"}
                            src={message.content} onClick={() => setVisible(true)}
                        />
                    }
                    {mime.includes("video") && 
                        <video className="message-video" controls src={message.content}> </video>
                    }
                </Row>
                <Row>
                    <Text style={{marginTop: 10, marginBottom: 2}}>{ mime.includes("not_available") ? "Esse story não está mais disponível": "Você foi mencionado em um story."}</Text>
                </Row>
            </Col>
        </>
        );
    }

    const renderImage = () => {
        return (
                <Image 
                    preview={visible} 
                    width={'100%'}
                    fallback={"https://storage.4bytes.com.br/public-uploads/image-error-fallback.png"}
                    src={contentUrl} 
                    onClick={() => setVisible(true)}
            />
        );
    }
    const renderSticker = () => {
        return (
            <Image 
                preview={false}
                width={'100%'}
                fallback={"https://storage.4bytes.com.br/public-uploads/image-error-fallback.png"}
                src={contentUrl} 
            />
        );
    }
    const renderLocation = () => {
        const [latitude, longitude, description] = message.content.split("||")

        if(latitude == "undefined" || longitude == "undefined"){
            return null;
        }

        return (
            <MapContainer className="map-content" center={[latitude, longitude]} zoom={13} scrollWheelZoom={false}>
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[latitude, longitude]}>
                    <Popup>
                        {description}
                    </Popup>
                </Marker>
            </MapContainer>
        );
    }
 
    let classes = []
    if(message.user_id){
        classes.push("from-me")
    }else if(message.chatbot_uuid){
        classes.push("from-bot")
    }else if(message.external_device){
        classes.push("from-me")
    }else{
        classes.push("from-them")
    }
    if(message.content_type === "location"){
        classes.push("location-message")
    }
    const onRevokeMessageClick = (message) => {
        if(onRevokeMessage){
            onRevokeMessage(message)
        }
    }
    const onReplyMessageClick = (message) => {
        if(onReplyMessage){
            onReplyMessage(message)
        }
    }
    let span_map = {
        "text": 22,
        "document": 22,
        "audio": 22,
        "ptt": 22,
        "video": 22,
        "location": 22,
        "story_mention": 22,
        "vcard": 22,
        "sticker": 4,
        "image": 12
    }

    let mobile_span_map = {
        "text": 22,
        "document": 22,
        "audio": 22,
        "ptt": 22,
        "video": 22,
        "location": 22,
        "story_mention": 22,
        "vcard": 22,
        "sticker": 22,
        "image": 22
    }
    const menu = [];
    if((message.status === 1 || message.status === 2)){
        menu.push(
            { 
                label: 'Responder Mensagem', 
                key: 'answer',
                onClick: ()=> onReplyMessageClick(message),
                icon: <FaReply/>
            }
        )
    }
    if((message.status === 1 || message.status === 2) && message.user_id){
        menu.push(
            { 
                label: 'Apagar Mensagem', 
                key: 'quote',
                onClick: ()=> onRevokeMessageClick(message),
                icon: <IoTrashOutline/>
            }
        )
    }
    const [metadata, setMetadata] = React.useState(null);
    React.useEffect(()=>{
        if(message?.metadata){
            try{
                setMetadata(JSON.parse(message?.metadata))
            }catch(err){
                setMetadata(null)
            }
        }
    },[message?.metadata])
    return (
        <Col {...viewProps} span={isMobile ? mobile_span_map[message.content_type]:span_map[message.content_type]} offset={classes?.join("").includes("from-me") ? 24 - span_map[message.content_type]: 0}  className={"imessage"} >
            <div className={classes.join(" ")} >
                {metadata?.ctwa_context && 
                    <Row justify="center" style={{backgroundColor: "#f0f0f0", alignItems:"center" }}>
                        <Image preview={false} width={72} src={metadata?.ctwa_context?.thumbnail||"https://storage.chatbee.com.br/public-uploads/error-image-generic.png"}/>
                        <Row>
                            <Button type="link" target='_blank' style={{color: "blue"}} href={metadata?.ctwa_context?.sourceUrl}>{metadata?.ctwa_context?.sourceUrl}</Button>
                        </Row>
                    </Row>
                }
                <Row style={{...style, minHeight: '16px'}} justify="space-between">
                    {!message.user_id  && message.external_device && renderExternalDevice()}
                    {!message.user_id  && !message.external_device && renderProfile()}
                    {message.user_id && renderUser()}
                    <Dropdown key="message-actions" trigger="click"  menu={{items: menu}}>
                        <Button  title='Ações' style={{ border: 'none', padding: 0, backgroundColor:"transparent", height: '16px' }}>
                            <IoChevronDown style={{color: "#8696a0", fontSize: '15px'}}/>
                        </Button>
                    </Dropdown>
                </Row>
                
                {message.quoted_message && <ChatMessageQuoted message={message.quoted_message}  contact={message.quoted_message?.contact} user={message.quoted_message.user}>
					{message.quoted_message.content}
				</ChatMessageQuoted>}
                
                <Row className="message-text">
                    {message.status !== 3 && message.content_type === 'text' && renderText()}
                    {message.status !== 3 && message.content_type === 'image' && <div className='message-media'>{renderImage()}</div>}
                    {message.status !== 3 && message.content_type === 'sticker' && <div className='sticker-media'>{renderSticker()}</div>}
                    {message.status !== 3 && message.content_type === 'document' && renderDocument()}
                    {message.status !== 3 && message.content_type === 'audio' && renderAudio()}
                    {message.status !== 3 && message.content_type === 'ptt' && renderAudio()}
                    {message.status !== 3 && message.content_type === 'video' && renderVideo()}
                    {message.status !== 3 && message.content_type === 'location' && renderLocation()}
                    {message.status !== 3 && message.content_type === 'story_mention' && renderStory()}
                    {message.status !== 3 && message.content_type === 'vcard' && renderVCard()}
                    {message.status !== 3 && message.content_type === 'buttons' && renderOptinRequest()}
                    {message.status !== 3 && message.content_type === 'template' && renderHSMTemplate()}
                    {message.status !== 3 && message.content_type === 'ptv' && renderPtv()}
                    {message.status === 3  && renderDeletedMessage()}
                    {metadata?.caption && 
                        <Text className='render-line-break'>{metadata?.caption}</Text>
                    }
                </Row>
                <Row className="timestamp" flex="auto" justify={"end"} align='middle'>
                    {message.received_at && renderDateElement()}
                    {message.status === -1 && <IoCloseSharp className='message-error-indicator'/>}
                    {message.status === 0 && <FaRegClock className='message-pending-indicator'/>}
                    {message.status === 4 && <IoCheckmarkSharp className='message-delivered-indicator'/>}
                    {message.status === 1 && <IoCheckmarkDoneSharp className='message-delivered-indicator'/>}
                    {message.status === 2 && <IoCheckmarkDoneSharp className='message-read-indicator'/>}
                </Row>
                {message.status !== 3 && message.content_type === 'buttons' && renderOptinRequestOptions()}
                {message.status !== 3 && message.content_type === 'buttons_response' && renderButtonsResponse()}
            </div>
        </Col>
    );
};